// extracted by mini-css-extract-plugin
export default {"number":"index_number__-4FDO"};